import { Input } from '@/components/Input';
import {
    selectVehicleKilometres,
    setVehicleKilometers,
} from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { userFacingAssetTitle } from '@/utils/userFacingAssetTitle';
import { getNumber } from '@/utils/valueFormat';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'Kilometers';

export function Kilometers({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    const currentState = useAppSelector(selectVehicleKilometres);
    const dispatch = useAppDispatch();
    const assetTitle = userFacingAssetTitle();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean): void {
        // MAXIMUM
        const MAXIMUM = 999999;
        const intValue = getNumber(value, MAXIMUM);
        if (intValue === currentState) return;
        dispatch(setVehicleKilometers(intValue));
    }

    // ***** Render *****
    return (
        <div data-testid={testId}>
            <Input
                title={`${assetTitle} Kilometers`}
                placeholder='Enter the number of kilometers'
                showErrors={showErrors}
                onChange={handleChange}
                id={`${baseId}-input-vehicleKilometers`}
                value={currentState?.toLocaleString() ?? ''}
                showNumpad={true}
                tooltipContent='Impacts the lender’s view of how much it is worth.'
            />
        </div>
    );
}
